/* IPPO Pro COD form: offers, gifts, extras, discount code, abandoned forms, order to the backend, Meta Pixel. */
(() => {
  if (customElements.get('lx-cod')) return;

  const CODE_KEY = 'lx-discount-code';
  const uuid = () =>
    window.crypto && crypto.randomUUID
      ? crypto.randomUUID()
      : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
          const r = (Math.random() * 16) | 0;
          return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });

  const formatMoney = (cents, format) => {
    const value = Math.round(Number(cents) || 0);
    const fmt = (n, decimals, thousands, decimal) => {
      const fixed = (n / 100).toFixed(decimals);
      const [int, frac] = fixed.split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return String(format || '{{amount}}').replace(/\{\{?\s*(amount\w*)\s*\}?\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return fmt(value, 2, "'", '.');
        default:
          return fmt(value, 2, ',', '.');
      }
    });
  };

  /* keeps "19.00 TND" in the right order inside Arabic text */
  const isolate = (text) => '\u2066' + text + '\u2069';

  const cookie = (name) => {
    const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  };

  let pixelReady = false;
  let pixelId = '';
  const loadPixel = (id) => {
    if (!id || pixelReady) return;
    pixelReady = true;
    pixelId = String(id).trim();
    if (!window.fbq) {
      /* Meta Pixel base code (no PageView: the Shopify Meta app already sends it) */
      const n = (window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      });
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const s = document.createElement('script');
      s.async = true;
      s.src = 'https://connect.facebook.net/en_US/fbevents.js';
      /* fbevents.js keeps a phone busy ~1 s: load it after the page (first touch, click, key or wheel, or 3 s after load).
         Calls made before that wait in fbq.queue and are sent once it loads. */
      const add = () => {
        if (s.isConnected) return;
        document.head.appendChild(s);
        wake.forEach((e) => window.removeEventListener(e, add));
      };
      const wake = ['pointerdown', 'keydown', 'touchstart', 'wheel'];
      wake.forEach((e) => window.addEventListener(e, add, { once: true, passive: true }));
      const later = () => setTimeout(add, 3000);
      document.readyState === 'complete' ? later() : window.addEventListener('load', later, { once: true });
    }
    if (window.bangaPixel !== pixelId) window.fbq('init', id); // BANGA: snippets/banga-pixel already started it
  };
  const track = (name, data, eventId) => {
    try {
      // only to the form's Pixel: other Pixels on the page (Meta app, other apps) don't get COD events
      if (window.fbq && pixelReady) window.fbq('trackSingle', pixelId, name, data, { eventID: eventId });
    } catch (e) {}
  };


  /* Ad attribution: utm_* / ad_id / fbclid of the visit, kept 30 days (last ad click wins) for the COD form */
  const ATTRIB_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ad_id', 'adset_id', 'campaign_id', 'fbclid'];
  const readAttrib = () => {
    const now = {};
    try {
      const q = new URLSearchParams(location.search);
      ATTRIB_KEYS.forEach((k) => {
        const v = q.get(k);
        if (v) now[k] = v.slice(0, 300);
      });
      if (Object.keys(now).length) {
        localStorage.setItem('lx-attrib', JSON.stringify(Object.assign({}, now, { at: Date.now() })));
        // Meta click ID: keep it as the standard _fbc cookie (90 days) so every later page and event can send it
        if (now.fbclid && document.cookie.indexOf(now.fbclid) === -1) {
          document.cookie = '_fbc=fb.1.' + Date.now() + '.' + now.fbclid + '; path=/; max-age=7776000; SameSite=Lax';
        }
        return now;
      }
      const saved = JSON.parse(localStorage.getItem('lx-attrib') || 'null');
      if (saved && Date.now() - (saved.at || 0) < 30 * 86400000) {
        delete saved.at;
        return saved;
      }
    } catch (e) {}
    return now;
  };

  let opener = null;

  /* The inline COD section lives in the overlays group; its form is shown inside the product block
     "COD form (place here)". Only the form moves (moving the whole section confuses the theme editor).
     Re-placed when the editor redraws the product section. */
  let codForm = null;
  const placeInSlot = (form) => {
    if (form) codForm = form;
    const slot = document.querySelector('[data-cod-slot]');
    if (!slot || !codForm) return;
    // an older copy of the same form left in the slot after the editor redrew the COD section
    slot.querySelectorAll('lx-cod').forEach((el) => el !== codForm && el.dataset.section === codForm.dataset.section && el.remove());
    if (slot.contains(codForm)) return;
    slot.querySelector('.lx-cod-slot__hint')?.remove();
    slot.appendChild(codForm); // the element keeps its state (this.ready) when it is moved
  };
  document.addEventListener('shopify:section:load', () => placeInSlot());

  class LxCod extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-cod-data]');
      if (!json || this.ready) return;
      this.ready = true;
      this.data = JSON.parse(json.textContent);
      this.t = this.data.texts || {};
      this.box = this.querySelector('[data-cod-box]');
      this.form = this.querySelector('[data-cod-form]');
      this.dialog = this.querySelector('.lxcod-dialog');
      this.home = this.box.parentElement;
      this.submitBtn = this.querySelector('[data-cod-submit]');
      this.submitLabel = this.querySelector('[data-cod-submit-label]');
      this.errorBox = this.querySelector('[data-cod-error]');
      this.startedAt = Date.now();
      this.upsells = new Set(Array.from(this.querySelectorAll('[name="upsell"]:checked')).map((i) => i.value));
      this.pieces = [];
      this.rates = null;
      this.discount = null;
      this.unlocked = new Set();
      this.firstVariant = (this.data.variants.find((v) => v.available) || this.data.variants[0] || {}).id;
      // BANGA: the form follows the colour and size chosen on the product page
      const onPage = this.pageVariant();
      if (onPage && onPage.available) this.firstVariant = onPage.id;
      document.addEventListener('change', (e) => {
        if (e.target.closest && e.target.closest('variant-selects')) this.followPage();
      });

      this.form.addEventListener('change', (e) => this.onChange(e));
      this.form.addEventListener('input', (e) => this.onInput(e));
      this.form.addEventListener('focusin', () => this.initiate(), { once: true });
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.submit();
      });
      this.querySelector('[data-cod-apply]')?.addEventListener('click', () => this.applyCode(this.querySelector('[data-cod-code]').value, true));
      this.querySelectorAll('[data-cod-close]').forEach((b) => b.addEventListener('click', () => this.close()));

      // Inline form placed into the "COD form (place here)" product block when there is one
      if (this.dataset.display !== 'popup') placeInSlot(this);

      if (!opener) {
        opener = this;
        this.bindOpeners();
      }
      if (this.dataset.design) this.bindEditor();
      loadPixel(this.data.pixel);
      this.selectOffer(this.currentOfferId(), true);
      this.setOfferImage(this.firstVariant);
      this.loadConfig();
      const fromLink = new URLSearchParams(location.search).get('code');
      if (fromLink) {
        try {
          localStorage.setItem(CODE_KEY, fromLink.trim().toUpperCase());
        } catch (e) {}
      }
      const saved = fromLink || this.savedCode();
      if (saved) this.applyCode(saved, false);
      document.addEventListener('lx:discount-code', (e) => this.applyCode(e.detail.code, false));
      if (this.dataset.preview && this.dataset.preview !== 'normal') this.preview(this.dataset.preview);
    }

    /* ---------------------------------------------------- theme editor */
    /* The editor scrolls to the section's real place (the overlays, at the bottom of the page):
       bring the preview back to the form in the product block, after the editor's own scroll. */
    bindEditor() {
      const mine = (e) => e.detail && e.detail.sectionId === this.dataset.section;
      const goTo = (el, block) => {
        if (!el || !this.isConnected) return;
        [120, 450].forEach((ms) => setTimeout(() => el.scrollIntoView({ block }), ms));
      };
      document.addEventListener('shopify:block:select', (e) => {
        if (!mine(e) || !this.isConnected) return;
        const id = e.detail.blockId;
        const card = this.querySelector(`[data-offer="${CSS.escape(id)}"]`);
        if (card) this.selectOffer(id);
        goTo(card || this.querySelector(`[data-gift="${CSS.escape(id)}"], [data-upsell="${CSS.escape(id)}"], [data-shopify-editor-block*="${CSS.escape(id)}"]`) || this.box, 'center');
      });
      ['shopify:section:select', 'shopify:section:load'].forEach((name) =>
        document.addEventListener(name, (e) => {
          if (mine(e)) goTo(this.box, 'start');
        })
      );
    }

    /* Editor preview of a form state (only in the theme editor) */
    preview(state) {
      if (state === 'gifts') {
        this.querySelectorAll('[data-gift]').forEach((g) => g.classList.add('is-unlocked'));
        this.previewGifts = true;
      } else if (state === 'code') {
        this.discount = { code: 'PROMO10', type: 'percentage', value: 10 };
        const input = this.querySelector('[data-cod-code]');
        if (input) input.value = 'PROMO10';
        const msg = this.querySelector('[data-cod-code-msg]');
        if (msg) {
          msg.textContent = this.t.codeOk;
          msg.hidden = false;
          msg.classList.add('is-ok');
        }
        this.update();
      } else if (state === 'thanks') {
        this.success({ orderName: '#1001', total: this.totals().total / 100, currency: this.data.currency, preview: true }, this.totals());
      }
    }

    /* ------------------------------------------------------------ data */
    offer(id) {
      return this.data.offers.find((o) => o.id === id) || null;
    }
    currentOfferId() {
      const checked = this.form.querySelector('[name="offer"]:checked');
      return checked ? checked.value : this.data.offers[0] ? this.data.offers[0].id : '';
    }
    quantity() {
      const o = this.offer(this.offerId);
      return o ? o.qty : 1;
    }
    catalogVariant(id) {
      for (const p of this.data.catalog || []) {
        const v = p.variants.find((x) => String(x.id) === String(id));
        if (v) return { product: p, variant: v };
      }
      return null;
    }
    variantPrice(id) {
      const v = this.data.variants.find((x) => String(x.id) === String(id));
      if (v) return v.price;
      const c = this.catalogVariant(id);
      return c ? c.variant.price : 0;
    }
    offerPrice(o, pieces) {
      const base = pieces.reduce((sum, id) => sum + this.variantPrice(id), 0);
      // BANGA: buy 2, get 1 free. Same rule as snippets/banga-bundle and backend/Cart.gs
      if (this.data.catalog) {
        const free = Math.floor(pieces.length / 3);
        const prices = pieces.map((id) => this.variantPrice(id)).sort((a, b) => b - a);
        return { base, total: prices.slice(free).reduce((sum, n) => sum + n, 0) };
      }
      let total = base;
      const value = Number(o.value) || 0;
      if (o.mode === 'total' && value > 0) total = Math.round(value * 100);
      else if (o.mode === 'percent') total = Math.round(base * (1 - Math.min(100, value) / 100));
      else if (o.mode === 'amount') total = base - Math.round(value * 100);
      return { base, total: Math.max(0, total) };
    }
    money(cents) {
      return formatMoney(cents, this.data.moneyFormat);
    }

    /* ---------------------------------------------------------- offers */
    selectOffer(id, initial) {
      this.offerId = id;
      this.querySelectorAll('.lxcod-offer').forEach((card) => {
        const active = card.dataset.offer === id;
        card.classList.toggle('is-active', active);
        const input = card.querySelector('input');
        if (input) input.checked = active;
      });
      const qty = this.quantity();
      const keep = this.pieces.slice(0, qty);
      while (keep.length < qty) keep.push(keep[keep.length - 1] || this.firstVariant);
      this.pieces = keep;
      this.renderVariants();
      this.update(initial);
      // the code may depend on the offer (minimum, offers it works with): check it again
      if (!initial && this.discount && !this.dataset.preview) {
        clearTimeout(this.codeTimer);
        this.codeTimer = setTimeout(() => this.applyCode(this.discount.code, false, true), 300);
      }
    }

    pageVariant() {
      const picker = document.querySelector('variant-selects');
      if (!picker) return null;
      const title = Array.from(picker.querySelectorAll('input:checked, select')).map((el) => el.value).join(' / ');
      return this.data.variants.find((v) => v.title === title) || null;
    }
    followPage() {
      const v = this.pageVariant();
      if (!v) return;
      this.firstVariant = v.id;
      const own = (id) => this.data.variants.some((x) => String(x.id) === String(id));
      this.pieces = this.pieces.map((id) => (own(id) ? v.id : id));
      this.renderVariants();
      this.update();
      this.setOfferImage(v.id);
    }
    setOfferImage(id) {
      const v = this.data.variants.find((x) => String(x.id) === String(id));
      if (!v || !v.image) return;
      this.querySelectorAll('.lxcod-offer__img img').forEach((img) => {
        img.removeAttribute('srcset');
        img.src = v.image;
      });
    }

    renderVariants() {
      this.querySelectorAll('[data-offer-variants]').forEach((el) => (el.innerHTML = ''));
      if (this.data.catalog && this.pieces.length >= 3) return this.renderPicks();
      if (this.data.catalog) return;
      const options = this.data.variants.filter((v) => v.title !== 'Default Title');
      if (options.length < 2) return;
      const card = this.querySelector(`.lxcod-offer[data-offer="${CSS.escape(this.offerId)}"] [data-offer-variants]`);
      if (!card) return;
      this.pieces.forEach((variantId, i) => {
        const label = document.createElement('label');
        label.innerHTML = `<span>${this.t.piece || ''} ${this.pieces.length > 1 ? i + 1 : ''}</span>`;
        const select = document.createElement('select');
        select.dataset.piece = i;
        this.data.variants.forEach((v) => {
          const o = document.createElement('option');
          o.value = v.id;
          o.textContent = v.title;
          o.disabled = !v.available;
          o.selected = String(v.id) === String(variantId);
          select.appendChild(o);
        });
        label.appendChild(select);
        card.appendChild(label);
      });
    }

    /* BANGA: each hoodie of the offer can be any model, so the free one really is the customer's choice */
    renderPicks() {
      const box = this.querySelector(`.lxcod-offer[data-offer="${CSS.escape(this.offerId)}"] [data-offer-variants]`);
      if (!box) return;
      this.pieces.forEach((variantId, i) => {
        const found = this.catalogVariant(variantId);
        if (!found) return;
        const isFree = (i + 1) % 3 === 0;
        const row = document.createElement('span');
        row.className = 'banga-pick' + (isFree ? ' banga-pick--free' : '');
        const img = document.createElement('img');
        img.alt = '';
        img.src = found.variant.image || '';
        const name = document.createElement('span');
        name.className = 'banga-pick__name';
        name.textContent = isFree ? this.t.freePiece : `${this.t.piece || ''} ${i + 1 - Math.floor(i / 3)}`;
        const model = document.createElement('select');
        model.dataset.pickModel = i;
        this.data.catalog.forEach((p) => {
          const o = document.createElement('option');
          o.value = p.id;
          o.textContent = p.title;
          o.selected = p.id === found.product.id;
          model.appendChild(o);
        });
        const size = document.createElement('select');
        size.dataset.piece = i;
        found.product.variants.forEach((v) => {
          const o = document.createElement('option');
          o.value = v.id;
          o.textContent = v.title;
          o.disabled = !v.available;
          o.selected = String(v.id) === String(variantId);
          size.appendChild(o);
        });
        row.append(img, name, model, size);
        box.appendChild(row);
      });
    }

    /* -------------------------------------------------------- calculate */
    totals() {
      const o = this.offer(this.offerId) || { qty: 1, mode: 'none', value: 0, freeShipping: false, title: '' };
      const { base, total: offerTotal } = this.offerPrice(o, this.pieces.length ? this.pieces : [this.firstVariant]);
      let extras = 0;
      this.data.upsells.forEach((u) => {
        if (this.upsells.has(u.id)) extras += u.price * (u.qty || 1);
      });
      const subtotal = offerTotal + extras;
      const compare = base + extras;
      let discount = 0;
      let freeShipCode = false;
      const d = this.discount;
      if (d) {
        if (d.type === 'percentage') discount = Math.round((subtotal * d.value) / 100);
        else if (d.type === 'fixed') discount = Math.min(subtotal, Math.round(d.value * 100));
        else if (d.type === 'fixed_each') discount = Math.min(subtotal, Math.round(d.value * 100 * o.qty));
        else if (d.type === 'free_shipping') freeShipCode = true;
      }
      let shipping = null;
      if (o.freeShipping || freeShipCode) shipping = 0;
      else if (this.rates) {
        const units = (subtotal - discount) / 100;
        const ok = this.rates.filter((r) => (!r.min || units >= r.min) && (!r.max || units <= r.max)).sort((a, b) => a.price - b.price);
        shipping = ok[0] ? Math.round(ok[0].price * 100) : 0;
      }
      return { offer: o, subtotal, compare, discount, shipping, total: subtotal - discount + (shipping || 0) };
    }

    update(initial) {
      // prices on each offer card (with the selected variants on the active card)
      this.data.offers.forEach((o) => {
        const card = this.querySelector(`.lxcod-offer[data-offer="${CSS.escape(o.id)}"]`);
        if (!card) return;
        const pieces = o.id === this.offerId ? this.pieces : Array(o.qty).fill(this.firstVariant);
        const { base, total } = this.offerPrice(o, pieces);
        const p = card.querySelector('[data-offer-price]');
        const c = card.querySelector('[data-offer-compare]');
        const save = card.querySelector('[data-offer-save]');
        const unit = card.querySelector('[data-offer-unit]');
        if (p) p.textContent = this.money(total);
        if (c) c.textContent = base > total ? this.money(base) : '';
        if (save) {
          save.hidden = !(base > total);
          save.textContent = (this.t.savings || '{amount}').replace('{amount}', isolate(this.money(base - total)));
        }
        if (unit) unit.textContent = (this.t.unit || '{amount}').replace('{amount}', isolate(this.money(Math.round(total / (o.qty || 1)))));
      });
      const t = this.totals();
      this.current = t;
      const set = (sel, text) => {
        const el = this.querySelector(sel);
        if (el) el.textContent = text;
      };
      set('[data-sum-subtotal]', this.money(t.subtotal));
      const cmp = this.querySelector('[data-sum-compare]');
      if (cmp) {
        cmp.hidden = !(t.compare > t.subtotal);
        cmp.textContent = this.money(t.compare);
      }
      const ship = this.querySelector('[data-sum-shipping]');
      if (ship) {
        ship.textContent = t.shipping === 0 ? this.t.free || 'FREE' : t.shipping == null ? (this.data.backend ? '…' : '—') : this.money(t.shipping);
        ship.classList.toggle('is-free', t.shipping === 0);
      }
      const dRow = this.querySelector('[data-sum-discount-row]');
      if (dRow) {
        dRow.hidden = !(t.discount > 0);
        set('[data-sum-discount]', '-' + this.money(t.discount));
        set('[data-sum-code]', this.discount ? `(${this.discount.code})` : '');
      }
      set('[data-sum-total]', this.money(t.total));
      this.updateGifts(initial);
    }

    updateGifts(initial) {
      const qty = this.quantity();
      const index = this.data.offers.findIndex((o) => o.id === this.offerId) + 1;
      const names = [];
      let next = null;
      this.data.gifts.forEach((g) => {
        const positions = String(g.offers || '')
          .split(/[,\s]+/)
          .map(Number)
          .filter(Boolean);
        const on = this.previewGifts || (g.mode === 'offers' ? positions.includes(index) : qty >= (g.min || 1));
        const el = this.querySelector(`[data-gift="${CSS.escape(g.id)}"]`);
        if (el) {
          const was = el.classList.contains('is-unlocked');
          el.classList.toggle('is-unlocked', on);
          if (on && !was && !initial) {
            el.classList.remove('just-unlocked');
            void el.offsetWidth;
            el.classList.add('just-unlocked');
          }
        }
        if (on) names.push(g.title);
        else if (g.mode !== 'offers' && (!next || g.min < next.min)) next = g;
      });
      const giftsRow = this.querySelector('[data-sum-gifts-row]');
      if (giftsRow) {
        giftsRow.hidden = !names.length;
        const el = this.querySelector('[data-sum-gifts]');
        if (el) el.textContent = names.join(' + ') + ' · ' + (this.t.free || 'FREE');
      }
      const progress = this.querySelector('[data-gift-progress]');
      if (progress) {
        if (next) {
          progress.textContent = (this.t.progress || '').replace('{n}', next.min - qty).replace('{gift}', next.title);
          progress.hidden = false;
        } else if (names.length && this.t.unlocked) {
          progress.textContent = this.t.unlocked;
          progress.hidden = false;
        } else {
          progress.hidden = true;
        }
      }
      this.giftNames = names;
    }

    /* ----------------------------------------------------------- events */
    onChange(e) {
      const el = e.target;
      if (el.name === 'offer') return this.selectOffer(el.value);
      if (el.name === 'upsell') {
        el.checked ? this.upsells.add(el.value) : this.upsells.delete(el.value);
        return this.update();
      }
      if (el.dataset.pickModel != null) {
        const i = Number(el.dataset.pickModel);
        const product = this.data.catalog.find((p) => String(p.id) === el.value);
        const before = this.catalogVariant(this.pieces[i]);
        const same = before && product.variants.find((v) => v.title === before.variant.title && v.available);
        const next = same || product.variants.find((v) => v.available) || product.variants[0];
        this.pieces[i] = next.id;
        this.renderVariants();
        return this.update();
      }
      if (el.dataset.piece != null) {
        this.pieces[Number(el.dataset.piece)] = el.value;
        if (Number(el.dataset.piece) === 0) this.setOfferImage(el.value);
        if (this.data.catalog && this.pieces.length >= 3) this.renderVariants();
        return this.update();
      }
      this.onInput(e);
    }

    onInput(e) {
      const el = e.target;
      if (el.name && el.closest('.lxcod-field')) this.clearError(el);
      if (['phone', 'name', 'region', 'city', 'address'].includes(el.name)) this.scheduleAbandon();
    }

    initiate() {
      if (this.initiated) return;
      this.initiated = true;
      this.initiateId = uuid();
      const t = this.totals();
      track('InitiateCheckout', { value: t.total / 100, currency: this.data.currency, content_ids: [String(this.data.product.id)], content_type: 'product', num_items: this.quantity() }, this.initiateId);
      this.post({ action: 'event', eventName: 'InitiateCheckout', eventId: this.initiateId, value: t.total / 100, productId: this.data.product.id, quantity: this.quantity(), page: location.href, meta: this.meta() }, true);
    }

    /* ------------------------------------------------------------ phone */
    phone() {
      const raw = (this.form.elements.phone?.value || '').trim();
      let digits = raw.replace(/\D/g, '');
      const code = String(this.data.phoneCode || '');
      if (code && digits.startsWith('00' + code)) digits = digits.slice(code.length + 2);
      else if (code && digits.startsWith(code) && digits.length > this.data.phoneDigits) digits = digits.slice(code.length);
      return digits.length === Number(this.data.phoneDigits) ? `+${code}${digits}` : '';
    }

    value(name) {
      return (this.form.elements[name]?.value || '').trim();
    }

    scheduleAbandon() {
      clearTimeout(this.abandonTimer);
      if (!this.data.backend || this.done) return;
      this.abandonTimer = setTimeout(() => {
        const phone = this.phone();
        if (!phone) return;
        const payload = {
          action: 'abandon',
          phone,
          name: this.value('name'),
          region: this.value('region'),
          city: this.value('city'),
          address: this.value('address'),
          offer: (this.offer(this.offerId) || {}).title || this.quantity() + ' pcs',
          total: this.totals().total / 100,
          page: location.href,
        };
        const key = JSON.stringify(payload);
        if (key === this.lastAbandon) return;
        this.lastAbandon = key;
        this.post(payload, true);
      }, 1500);
    }

    /* ------------------------------------------------------- discounts */
    savedCode() {
      try {
        return localStorage.getItem(CODE_KEY) || '';
      } catch (e) {
        return '';
      }
    }

    async applyCode(raw, manual, recheck) {
      const code = String(raw || '').trim().toUpperCase();
      const input = this.querySelector('[data-cod-code]');
      const msg = this.querySelector('[data-cod-code-msg]');
      const show = (text, ok) => {
        if (!msg) return;
        msg.textContent = text;
        msg.hidden = !text;
        msg.classList.toggle('is-ok', !!ok);
        msg.classList.toggle('is-error', !ok);
      };
      if (!code) {
        this.discount = null;
        show('', true);
        return this.update();
      }
      if (input) input.value = code;
      if (!this.data.backend) return;
      const seq = (this.codeSeq = (this.codeSeq || 0) + 1);
      const t = this.totals();
      const res = await this.post({
        action: 'discount',
        code,
        subtotal: t.subtotal / 100,
        quantity: this.quantity(),
        productId: this.data.product.id,
        template: this.data.template,
        sectionId: this.data.sectionId,
        offerBlockId: this.offerId,
        phone: this.phone(),
      });
      if (seq !== this.codeSeq) return; // a newer code check is running
      if (res && res.ok) {
        this.discount = res;
        show(this.t.codeOk, true);
        try {
          localStorage.setItem(CODE_KEY, code);
        } catch (e) {}
      } else {
        this.discount = null;
        if (manual || recheck) show(this.t.code, false);
      }
      this.update();
    }

    /* --------------------------------------------------------- backend */
    meta() {
      let fbc = cookie('_fbc');
      const fbclid = new URLSearchParams(location.search).get('fbclid');
      if (!fbc && fbclid) fbc = `fb.1.${Date.now()}.${fbclid}`;
      if (!fbc) {
        try {
          const saved = JSON.parse(localStorage.getItem('lx-attrib') || 'null');
          if (saved && saved.fbclid && Date.now() - (saved.at || 0) < 90 * 86400000) fbc = `fb.1.${saved.at}.${saved.fbclid}`;
        } catch (e) {}
      }
      return { fbp: cookie('_fbp'), fbc, userAgent: navigator.userAgent, page: location.href, attrib: readAttrib() };
    }

    async post(body, quiet) {
      if (!this.data.backend) return null;
      // template + section let the backend read this form's settings (offers, codes, Meta, Sheet)
      const payload = JSON.stringify(Object.assign({ shop: this.data.shop, template: this.data.template, sectionId: this.data.sectionId }, body));
      try {
        const res = await fetch(this.data.backend, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: payload,
          keepalive: quiet && payload.length < 60000,
        });
        return await res.json();
      } catch (e) {
        return quiet ? null : { ok: false, error: 'network' };
      }
    }

    async loadConfig() {
      if (!this.data.backend) return;
      const key = `lx-cod-config-${this.data.shop}`;
      try {
        const hit = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (hit && hit.until > Date.now()) {
          this.rates = hit.rates;
          return this.update();
        }
      } catch (e) {}
      const res = await this.post({ action: 'config', country: this.data.country }, true);
      if (res && res.ok) {
        this.rates = (res.shipping && res.shipping.rates) || [];
        try {
          sessionStorage.setItem(key, JSON.stringify({ rates: this.rates, until: Date.now() + 600000 }));
        } catch (e) {}
        this.update();
      }
    }

    /* ---------------------------------------------------------- submit */
    validate() {
      let first = null;
      this.form.querySelectorAll('.lxcod-field input, .lxcod-field select, .lxcod-field textarea').forEach((el) => {
        let message = '';
        if (el.required && !el.value.trim()) message = this.t.required;
        else if (el.name === 'phone' && el.value.trim() && !this.phone()) message = this.t.phone;
        if (message) {
          this.setError(el, message);
          first = first || el;
        }
      });
      if (first) first.focus();
      return !first;
    }
    setError(el, message) {
      const field = el.closest('.lxcod-field');
      field?.querySelector('.lxcod-input')?.classList.add('is-invalid');
      const p = field?.querySelector('[data-field-error]');
      if (p) {
        p.textContent = message;
        p.hidden = false;
      }
    }
    clearError(el) {
      const field = el.closest('.lxcod-field');
      field?.querySelector('.lxcod-input')?.classList.remove('is-invalid');
      const p = field?.querySelector('[data-field-error]');
      if (p) p.hidden = true;
    }
    showError(text) {
      this.errorBox.textContent = text;
      this.errorBox.hidden = !text;
    }
    busy(on) {
      this.submitBtn.disabled = on;
      this.submitBtn.classList.toggle('is-loading', on);
      if (!this.labelText) this.labelText = this.submitLabel.textContent;
      this.submitLabel.textContent = on ? this.t.loading || '…' : this.labelText;
      clearTimeout(this.loadingTimer);
      if (on && this.t.loading2) this.loadingTimer = setTimeout(() => (this.submitLabel.textContent = this.t.loading2), 2000);
    }

    lines() {
      const counts = {};
      this.pieces.forEach((id) => (counts[id] = (counts[id] || 0) + 1));
      return Object.keys(counts).map((id) => ({ variantId: Number(id), quantity: counts[id] }));
    }

    /* BANGA: switch to the 2 + 1 free offer, keeping the current hoodie as the first one */
    takeOffer(picks) {
      const offer = this.data.offers.find((o) => o.qty >= 3);
      if (!offer) return;
      const first = this.pieces[0] || this.firstVariant;
      this.selectOffer(offer.id);
      this.pieces = [first, ...picks.map((p) => p.variantId)];
      this.renderVariants();
      this.update();
    }

    async submit() {
      if (this.sending || this.done) return;
      this.showError('');
      if (!this.validate()) return;
      // BANGA: one hoodie only: remind the customer of the offer once. Closing the popup stays on the form; skipping sends the order.
      if (this.data.catalog && this.pieces.length === 1 && !this.offerAnswered && window.BangaOffer) {
        window.BangaOffer.open({
          needed: 2,
          basePrices: [this.variantPrice(this.pieces[0])],
          defaultProductId: this.data.product.id,
          onAccept: (picks) => {
            this.offerAnswered = true;
            window.BangaOffer.close();
            this.takeOffer(picks);
            this.submit();
          },
          onSkip: () => {
            this.offerAnswered = true;
            this.submit();
          },
        });
        return;
      }
      if (!this.data.backend) return this.fallback();
      this.sending = true;
      this.busy(true);
      this.requestId = this.requestId || uuid();
      this.eventId = this.eventId || uuid();
      const t = this.totals();
      const body = {
        action: 'order',
        cart: !!this.data.catalog,
        requestId: this.requestId,
        eventId: this.eventId,
        template: this.data.template,
        sectionId: this.data.sectionId,
        productId: this.data.product.id,
        offerBlockId: this.offerId,
        lines: this.lines(),
        upsells: Array.from(this.upsells),
        discountCode: this.discount ? this.discount.code : '',
        customer: {
          name: this.value('name'),
          phone: this.phone(),
          region: this.value('region'),
          city: this.value('city'),
          address: this.value('address'),
          note: this.value('note'),
          email: this.value('email'),
        },
        meta: this.meta(),
        honeypot: this.form.elements.lxcod_trap ? this.form.elements.lxcod_trap.value : '',
        elapsedMs: Date.now() - this.startedAt,
      };
      let res = await this.post(body);
      if (!res || res.error === 'network' || res.error === 'server_error') {
        await new Promise((r) => setTimeout(r, 1500));
        res = await this.post(body);
      }
      this.sending = false;
      if (res && res.ok) return this.success(res, t);
      this.busy(false);
      const errors = {
        duplicate: this.t.duplicate,
        blocked: this.t.error,
        invalid_phone: this.t.phone,
        out_of_stock: this.t.stock,
        invalid_code: this.t.code,
        code_already_used: this.t.code,
        missing_name: this.t.required,
      };
      if (res && errors[res.error]) {
        if (res.error === 'invalid_code' || res.error === 'code_already_used') {
          this.discount = null;
          try {
            localStorage.removeItem(CODE_KEY);
          } catch (e) {}
          this.update();
        }
        return this.showError(errors[res.error]);
      }
      // shopify_failed, network, price_mismatch, form_not_found…: never lose the sale
      this.fallback();
    }

    success(res, t) {
      this.done = !res.preview;
      clearTimeout(this.abandonTimer);
      if (!res.preview) {
        try {
          const digits = this.phone().replace(/\D/g, '');
          const parts = this.value('name').toLowerCase().split(/\s+/).filter(Boolean);
          const am = { ph: digits, external_id: 'ph:' + digits };
          if (parts[0]) am.fn = parts[0];
          if (parts.length > 1) am.ln = parts.slice(1).join(' ');
          if (this.value('city')) am.ct = this.value('city').toLowerCase().replace(/\s+/g, '');
          if (this.data.country) am.country = String(this.data.country).toLowerCase();
          if (digits && window.fbq && pixelReady) window.fbq('init', pixelId, am);
        } catch (e) {}
      }
      if (!res.preview) track(
        'Purchase',
        { value: res.total, currency: res.currency || this.data.currency, content_ids: [String(this.data.product.id)], content_type: 'product', num_items: this.quantity() },
        this.eventId
      );
      const thanks = this.querySelector('[data-cod-thanks]');
      this.querySelector('[data-cod-thanks-text]').textContent = (this.t.thanks || '').replace('{order}', res.orderName || '');
      const summary = this.querySelector('[data-cod-thanks-summary]');
      const rows = [
        [(this.offer(this.offerId) || {}).title || this.data.product.title, ''],
        ...(this.giftNames || []).map((n) => ['🎁 ' + n, this.t.free || 'FREE']),
        [this.querySelector('.lxcod-row--total span')?.textContent || 'Total', formatMoney(Math.round(res.total * 100), this.data.moneyFormat)],
      ];
      summary.innerHTML = '';
      rows.forEach(([a, b]) => {
        const p = document.createElement('p');
        p.className = 'lxcod-row';
        p.innerHTML = '<span></span><b></b>';
        p.firstChild.textContent = a.replace(/<[^>]+>/g, '');
        p.lastChild.textContent = b;
        summary.appendChild(p);
      });
      const wa = this.querySelector('[data-cod-whatsapp]');
      if (wa && this.data.whatsapp) {
        wa.href = `https://wa.me/${String(this.data.whatsapp).replace(/\D/g, '')}?text=${encodeURIComponent((this.t.whatsapp || '').replace('{order}', res.orderName || ''))}`;
        wa.hidden = false;
      }
      this.busy(false);
      this.form.hidden = true;
      thanks.hidden = false;
      if (res.preview) return;
      thanks.scrollIntoView({ behavior: 'smooth', block: 'center' });
      document.dispatchEvent(new CustomEvent('lx:cod-order', { detail: res }));
    }

    /* Normal checkout with the same products when the backend can't take the order */
    async fallback() {
      this.busy(true);
      try {
        const items = this.lines().map((l) => ({ id: l.variantId, quantity: l.quantity }));
        await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
      } catch (e) {}
      const code = this.discount ? this.discount.code : this.savedCode();
      location.href = '/checkout' + (code ? `?discount=${encodeURIComponent(code)}` : '');
    }

    /* ------------------------------------------------------ open/close */
    bindOpeners() {
      document.addEventListener(
        'click',
        (e) => {
          const t = e.target;
          let hit = t.closest('a[href$="#cod-form"], [data-cod-open]');
          if (!hit && this.dataset.sticky === 'true') hit = t.closest('[data-lx-satc-btn]');
          if (!hit && this.dataset.intercept === 'true') hit = t.closest('[id^="ProductSubmitButton-"], .shopify-payment-button__button, product-form [type="submit"]');
          if (!hit || this.contains(hit)) return;
          e.preventDefault();
          e.stopPropagation();
          this.open();
        },
        true
      );
      if (location.hash === '#cod-form') setTimeout(() => this.open(), 400);
    }

    open() {
      if (this.dataset.display === 'popup') {
        if (!this.dialog.open) this.dialog.showModal();
        return;
      }
      if (this.dataset.open === 'scroll') {
        this.box.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setTimeout(() => this.form.querySelector('input:not([type=radio]):not([type=checkbox]):not(.lxcod-hp)')?.focus({ preventScroll: true }), 600);
        return;
      }
      if (!this.drawer) {
        this.drawer = document.createElement('dialog');
        this.drawer.className = 'lxcod-dialog';
        this.drawer.setAttribute('dir', this.getAttribute('dir'));
        this.drawer.addEventListener('close', () => this.restore());
        this.drawer.addEventListener('click', (e) => {
          if (e.target === this.drawer) this.close();
        });
        this.appendChild(this.drawer);
      }
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'lxcod-close';
      close.setAttribute('aria-label', 'Close');
      close.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path fill="currentColor" d="M19 6.4 17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12z"/></svg>';
      close.addEventListener('click', () => this.close());
      this.box.prepend(close);
      this.tempClose = close;
      this.drawer.appendChild(this.box);
      this.drawer.showModal();
    }

    restore() {
      this.tempClose?.remove();
      this.tempClose = null;
      if (this.box.parentElement !== this.home) this.home.appendChild(this.box);
    }

    close() {
      if (this.dialog?.open) this.dialog.close();
      if (this.drawer?.open) this.drawer.close();
    }
  }

  customElements.define('lx-cod', LxCod);
})();
